<template><td>
     <div class="km-widget km-buttongroup k-widget k-button-group k-button-narrow">

                    <button v-for="ukaz in ukazi"
                        :class=izgled(ukaz)
                        @click="akcija(ukaz.akcija,$event,ukaz.newtab)" :title="title(ukaz)">
                         <font-awesome-icon :icon="ukaz.icon"/>
                    </button>
                    
                  
                    </div>
</td>
</template>
<script>
export default {
props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        shema: String,
        sezona: Number,
        podshema:String,
        kontrolaid:String,
        ukazi:Array
    },
    created() {
       /* console.log(this.ukazi);
        console.log("delam gumbe!!!");
        console.log(this.dataItem);
        */
    },
    methods: {
      title:function(ukaz){
         if(ukaz.akcija=="ipprijava"){
            let text="Prijava";
               if(!this.dataItem.popolnaprijava&&this.dataItem.eprijavaoddana&&this.dataItem.eprijavaposlana){
                  return "E-prijava je sprejeta in ni zaključena";
               }
               if(this.dataItem.eprijavaposlana&&!this.dataItem.eprijavaoddana){
                  return "E-Prijava je bila poslana po pošti in še ni oddana";
               }
               if(!this.dataItem.eprijavaposlana&&!this.dataItem.popolnaprijava){
                  return "Prijava ni bila poslana preko epošte in ni popolna";
               }
               return text;
            }
         return ukaz.title;
      },
         izgled:function(ukaz){
            var look={
               "k-primary": true,
               "k-button":true,
               "k-grid-edit-command": true,
               "k-warning":false,
               "k-info":false
            }
            
            if(ukaz.akcija=="kontrolaukrepip"){
               
                  if(this.dataItem.iukrepstatus=="odprti"){
                     look["k-primary"]=false;
                     look["k-warning"]=true;
                     look["k-info"]=false;
                     look["k-error"]=false;
                  }


                  if(this.dataItem.iukrepstatus=="zamujeni"){
                     look["k-primary"]=false;
                     look["k-warning"]=false;
                     look["k-info"]=false;
                     look["k-error"]=true;

                  }

                  
                  
                  

            }
            if(ukaz.akcija=="pripravakontroleip"){
               look["k-info"]=true;
                  if(this.dataItem.nukrepstatus=="odprti"){
                     look["k-primary"]=false;
                     look["k-warning"]=false;
                     look["k-info"]=true;
                     look["k-error"]=false;
                  }
               }
            
            if(ukaz.akcija=="neskladjaip"){
               if(this.dataItem.neskladjastatus=="odprta"){
                 
                     look["k-primary"]=false;
                     look["k-warning"]=true;
                     look["k-info"]=false;
                     look["k-error"]=false;
                  }


                  if(this.dataItem.neskladjastatus=="zamujena"){
                     look["k-primary"]=false;
                     look["k-warning"]=false;
                     look["k-info"]=false;
                     look["k-error"]=true;

                  }
            }



            if(ukaz.akcija=="ipprijava"){
               if(!this.dataItem.popolnaprijava&&this.dataItem.eprijavaoddana){
                  look["k-primary"]=false;
                  look["k-warning"]=true;
                  look["k-info"]=false;

               }
               if(this.dataItem.eprijavaposlana&&!this.dataItem.eprijavaoddana&&!this.dataItem.popolnaprijava){
                  look["k-primary"]=false;
                  look["k-warning"]=false;
                  look["k-info"]=true;
               }
               if(this.dataItem.eprijavaposlana===false&&!this.dataItem.popolnaprijava){
                  look["k-primary"]=false;
                  look["k-error"]=true;
                  look["k-info"]=false;
               }
               
               
            }
            if(ukaz.akcija=="pridelovalec"){
               if(!this.dataItem.popolnaprijava&&this.dataItem.eprijavaoddana){
                  look["k-primary"]=false;
                  look["k-warning"]=true;
                  look["k-info"]=false;

               }
               if(this.dataItem.eprijavaposlana&&!this.dataItem.eprijavaoddana&&!this.dataItem.popolnaprijava){
                  look["k-primary"]=false;
                  look["k-warning"]=false;
                  look["k-info"]=true;
               }
               if(this.dataItem.eprijavaposlana===false&&!this.dataItem.popolnaprijava){
                  look["k-primary"]=false;
                  look["k-warning"]=false;
                  look["k-info"]=false;
                  look["k-error"]=true;
               }

               
               
               
               
            }

            return look;
         },
        akcija: function(akcija,event,newtab) {
           //this.select({pridelovalec:this.dataItem});
           console.log(akcija);
           console.log(event);
           console.log(this.dataItem);
           console.log(this.sezona);
           //,sezona:sezona,shema:shema,pridelovalecid:pridelovalecid,
           if(event.ctrlKey||newtab){
            const routeData = this.$router.resolve({ name: akcija, params: { podshema:this.podshema,kontrolaid:this.kontrolaid,sezona: this.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id, ukazi:this.ukazi, shema:this.shema } });
            window.open(routeData.href, '_blank');
           }
           else
           this.$router.push({ name: akcija, params: { podshema:this.podshema,kontrolaid:this.kontrolaid, sezona: this.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id, ukazi:this.ukazi, shema:this.shema } })
            
        },

        
        prikaziGerke: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'gerk', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id } })
            
        },
        urediStranko: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'dodajStranko', params: { strankaid:this.dataItem._id } })
            
        },
        urediKulture: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'kultura', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id } })
            
        },
          urediZivali: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'zival', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id } })
            
        },
          urediProizvode: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'proizvod', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id } })
            
        },
           urediKontrole: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'home', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id } })
            
        },
           urediOdlocbe: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'home', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id } })
            
        },
         urediCertifikat: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'certifikat', params: { sezona: this.dataItem.sezona, pridelovalec:this.dataItem, pridelovalecid:this.dataItem._id } })
            
        }
         
    }
}


</script>
